import { ReactNode } from "react";
import { Navigate } from "react-router-dom";
import { useTeamRole } from "@/hooks/useTeamRole";
import { can, PermissionKey } from "@/lib/permissions";

interface RoleRouteProps {
  permission: PermissionKey;
  children: ReactNode;
  /** Where to send users who lack the permission. Defaults to "/" (or "/tasks" for staff). */
  fallback?: string;
}

export default function RoleRoute({ permission, children, fallback }: RoleRouteProps) {
  const { teamRole, loading } = useTeamRole();

  if (loading) {
    return (
      <div className="flex items-center justify-center py-24">
        <div className="h-8 w-8 animate-spin rounded-full border-4 border-gold border-t-transparent" />
      </div>
    );
  }

  if (!can(teamRole, permission)) {
    const dest = fallback ?? (teamRole === "staff" ? "/tasks" : "/");
    return <Navigate to={dest} replace />;
  }

  return <>{children}</>;
}
